interface ControlData {
  prevalence?: number;
  specificity?: number;
  [key: string]: any;
}

interface AltTextData {
  afp: number;
  atn: number;
}

const updateFunc = (controlData: ControlData): AltTextData => {
  const prevalence =
    controlData["prevalence"] !== undefined ? controlData["prevalence"] : 10;
  const specificity =
    controlData["specificity"] !== undefined ? controlData["specificity"] : 95;

  const h = 1000 - prevalence;
  const fp = 100 - specificity;
  const tn = specificity;
  const fpr = fp / 100;
  const tnr = tn / 100;
  const afp = fpr * h;
  const atn = tnr * h;

  const calculatedData: AltTextData = {
    afp: Math.round(afp),
    atn: Math.round(atn),
  };
  return calculatedData;
};

export default updateFunc;
